// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"ba7bc2f6","158":"6878a100","238":"0e213ef3","667":"9233fcb5","771":"afd0f4de","809":"a6ab1215","913":"3fa44aef","997":"dd1c089a"}[chunkId] + ".chunk.js";
};